import React from "react";

const SummaryCircle = ({ label, value, color, total = 30 }) => {
  const colors = {
    green: "#10b981", // modern emerald
    red: "#ef4444",   // modern red
    blue: "#3b82f6",  // modern blue
    orange: "#f97316",// modern orange
    yellow: "#f59e0b",// modern amber
    gray: "#6b7280",  // modern gray
    pink: "#ec4899",  // modern pink
    purple: "#8b5cf6",// modern purple
  };

  const radius = 32;
  const stroke = 5;
  const normalizedRadius = radius - stroke * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;

  const progress = value / (total || 1);
  const strokeDashoffset = circumference - Math.min(progress, 1) * circumference;

  return (
    <div className="flex flex-col items-center bg-slate-50/60 hover:bg-white p-4 rounded-2xl border border-slate-100 hover:border-blue-100 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 cursor-pointer w-full min-w-[90px]">
      <svg height={radius * 2} width={radius * 2} className="drop-shadow-sm">
        <circle
          stroke="#f1f5f9"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />

        <circle
          stroke={colors[color] || "#6b7280"}
          fill="transparent"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${circumference} ${circumference}`}
          style={{ strokeDashoffset, transition: "stroke-dashoffset 0.5s ease-in-out" }}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          transform={`rotate(-90 ${radius} ${radius})`}
        />

        <text
          x="50%"
          y="50%"
          dominantBaseline="central"
          textAnchor="middle"
          style={{ fill: colors[color] || "#1e293b", fontWeight: "800" }}
          className="text-sm font-sans"
        >
          {value}
        </text>
      </svg>

      <p className="mt-3 text-xs font-semibold text-slate-600 text-center tracking-wide uppercase">
        {label}
      </p>
    </div>
  );
};

export default SummaryCircle;
